import React from 'react';
import { observer } from 'mobx-react-lite';
import { SelectionButton } from '../../../../shared/selection-button/selection-button';
import { ExportOptions } from './export-options';
import { useStores } from '../../../../store';
import { exportData } from '../../../../../utils/file-utils';
import { dateFormat, LOGS_FORMAT, TIMESTAMP_DATE_FORMAT } from '../../../../../utils/datesUtils';
import { EventType } from 'src/dtos/analytics.dto';
import { DisableReasons } from '../../../../../utils/enums';


export const ExportLogs: React.FC = observer(() => {
    const { logsStore, userStore } = useStores();

    const onSelectedExportMethod = (value: any) => {
        logsStore.setExportMethod(value);
        onExport();
    };

    const fileName = `${logsStore.selectedLogsType}_${dateFormat(new Date(), LOGS_FORMAT)}_${userStore.emailPrefix}`;

    const onExport = () => {
        if (logsStore.logsByType.length < logsStore.maxLogsForLocalDownload) {
            logsStore.logsByType.forEach(item => item['Date & Time'] = dateFormat(new Date(item['Date & Time']), TIMESTAMP_DATE_FORMAT));
            exportData(logsStore.logsByType, logsStore.exportMethod.key, fileName, logsStore.columnConfigByType);
            logsStore.sendExportLogEvent(EventType.LogsExport, logsStore.exportMethod.key, new Map([[logsStore.selectedLogsType, logsStore.currentSearchCriteria]]));
        }
    };

    return <SelectionButton options={ExportOptions} onClick={onExport} label={'Export Results'} prefixIconType={logsStore.exportMethod.icon} width={230}
        onSelect={onSelectedExportMethod}
        disable={logsStore.logsByType.length < 1 || logsStore.logsByType.length === logsStore.maxLogsForLocalDownload}
        disableReason={logsStore.logsByType.length === logsStore.maxLogsForLocalDownload ? DisableReasons.MAX_LOG_FOR_LOCAL_DOWNLOAD : ''}/>;
});